import request from '@/utils/request'


// 查询宠物体重记录列表
export function listWeightRecord(query) {
  return request({
    url: '/mibo/pet-weight-record/list',
    method: 'get',
    params: query
  })
}

// 查询宠物体重记录分页
export function pageWeightRecord(query) {
  return request({
    url: '/mibo/pet-weight-record/page',
    method: 'get',
    params: query
  })
}

// 查询宠物体重记录详细
export function getWeightRecord(data) {
  return request({
    url: '/mibo/pet-weight-record/detail',
    method: 'get',
    params: data
  })
}

// 新增宠物体重记录
export function addWeightRecord(data) {
  return request({
    url: '/mibo/pet-weight-record/add',
    method: 'post',
    data: data
  })
}

// 修改宠物体重记录
export function updateWeightRecord(data) {
  return request({
    url: '/mibo/pet-weight-record/edit',
    method: 'post',
    data: data
  })
}

// 删除宠物体重记录
export function delWeightRecord(data) {
  return request({
    url: '/mibo/pet-weight-record/delete',
    method: 'post',
    data: data
  })
}
